import React, {useEffect, useState} from 'react'
import { Form, FormControl, Tab, Tabs } from 'react-bootstrap'
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import { fetchGiveawayList } from '../../api/api';
const GiveawayList = () => {
   const [data, setData] = useState(null);
    const handleSubmit = async () => {
   
        const response = await fetchGiveawayList();
        console.log(response);
        if(response.success){
            setData(response.data);
            
        }else{
            // Swal.fire('Failed', response.message, 'error')
            Swal.fire({
                title: 'Failed',
                icon:"error",
                confirmButtonColor: 'red',
                confirmButtonText: 'Close',
                html:`<b class='text-danger'>${response.message}</b>`,
                // closeButtonHtml: `<button className="btn btn-color"> Close </button>`
            })
        }
      
    //   window.stop_load();
    }

    useEffect(() => {
        // console.log(data);
        handleSubmit()
        document.title = 'Give Away List | Taste Place Investment'
    }, [])
  return (
    <div className='giveaway m-1 px-2 py-5'
    style={{ 
        // backgroundColor: 'whitesmoke',
        height: '99vh'
     }}
    >
        {/* <div className=' d-flex justify-content-center mb-2' > */}
            <div className='text-center'>
                <img src='/tph_logo.png' width={'50px'} height={'50px'} alt='logo' />
            </div>
            <h3 className='text-center'><b className=" mb-5 header-body-title text-center"> Taste Place IT Officer's Baby Naming Give-Away Lucky Winners List </b></h3> 
            <div className='row justify-content-center'>
                <div className='col-8'>
                    <div className='d-flex justify-content-center'>
                            <table className='table w-100'>
                                <tr>
                                    <th> S/N </th>
                                    <th> Ref </th>
                                    <th> NAME </th>
                                    <th> Unit </th>
                                    <th> Phone </th>
                                    <th> Network </th>
                                    <th> Date/Time </th>
                                </tr>
                                {
                                    data && data.map((d, i) => (
                                        <tr>
                                            <td>{i+1}</td>
                                            <td>{'TPI'+i+1}</td>
                                            <td>{d.name}</td>
                                            <td>{d.unit}</td>
                                            <td>{d.phone}</td>
                                            <td>{d.network}</td>
                                            <td>{d.created_at}</td>
                                        </tr>
                                    ))
                                }
                                </table>
                    </div>
                </div>
            </div>
    </div>
  )
}

export default GiveawayList